module.exports = __webpack_public_path__ + "img/department_icon8.f60da564.png";